import { StarIcon } from 'components/icons/StarIcon';
import { useState } from 'react';

interface IPollStarRate {
  handleRateChange: any;
  questionNum: number;
  responses: any;
}

const PollStarRate = ({ handleRateChange, questionNum, responses }: IPollStarRate) => {
  return (
    <>
      <div className="my-3">
        <span>1 - Poor</span>
        <span className="ml-4">5 - Excellent</span>
      </div>
      <div className="flex flex-col items-center border border-black border-opacity-10 py-10 rounded-lg">
        <p className="text-center text-sm leading-6 px-4 pt-4">Give your rating</p>
        <div className="flex my-5 gap-3">
          {[1, 2, 3, 4, 5].map((star) => (
            <div
              className="w-10 h-10 bg-black bg-opacity-5 rounded-lg flex items-center justify-center cursor-pointer"
              key={star}
            >
              <StarIcon
                onClick={() => {
                  handleRateChange(questionNum, star);
                }}
                className={`${star <= (responses[questionNum] || 0) ? 'fill-red-main' : ''} w-8 h-8`}
                fill={star <= (responses[questionNum] || 0) ? 'red' : ''}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PollStarRate;
